export default __webpack_public_path__ + "static/media/intermediate.5f83bd21.svg";